import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterStateLackOfReconciliation } from "./types";

const INITIAL_STATE: FilterStateLackOfReconciliation = {
  filters: {
    search: "",
    meta: {
      page: 1,
      perPage: 10,
    },
  },
  activeTab: "lack",
  dateRange: {
    from: null,
    to: null,
  },
};

const lackOfReconciliationFilterSlice = createSlice({
  name: "lackOfReconciliationFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setLackOfReconciliationFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
    setLackOfReconciliationActiveTab(
      state,
      action: PayloadAction<"lack" | "status-grid">
    ) {
      state.activeTab = action.payload;
    },
    setLackOfReconciliationDateRange(
      state,
      action: PayloadAction<{ from: string | null; to: string | null }>
    ) {
      state.dateRange = action.payload;
    },
  },
});

export const {
  setLackOfReconciliationFilter,
  setLackOfReconciliationActiveTab,
  setLackOfReconciliationDateRange,
} = lackOfReconciliationFilterSlice.actions;
export default lackOfReconciliationFilterSlice.reducer;
